module.exports = __webpack_public_path__ + "static/media/blue.1c904b34.ogg";